import { isArray } from "lodash";
import React from "react";
import { useState } from "react";
import { ChargeType } from "Util/Enum";
import { Div, Img, Txt } from "Components/GenericView";
import { SMILEY_VISIT_DETAILS } from "Constants";

const ChargeDetails: React.FunctionComponent<any> = ({ chargeDetails }) => {
  const [isErrorDetail, setErrorDetail] = useState(false);
  const { charge_status } = chargeDetails;
  const { type } = chargeDetails;
  const card_used = chargeDetails?.payment_method?.card_used;

  const renderDetailRow = (key: string, value: string) => {
    if (!value) return null;
    return (
      <Div className="flex justify-between fs-13 wa-tr-row">
        <Txt color="#757588">{key}</Txt>
        <Txt color="#22234E">{value}</Txt>
      </Div>
    );
  };
  const renderPackageUsed = (key: string, value: any) => {
    if (!value || !isArray(value)) return null;
    if (value.length > 1) {
      return value?.map((row: any, index: number) => (
        <Div className="flex justify-between fs-13 wa-tr-row center">
          <Div color="#757588" h vc>
            <Txt>{key}</Txt>
            <Txt
              ml={7}
              bg="rgba(216, 216, 216, 0.3)"
              br={5}
              p="2px 6px 0px 6px"
            >{`${index + 1} of ${value.length}`}</Txt>
          </Div>
          <Div className="text-right">
            <Txt color="#22234E" b>
              {row.name}
            </Txt>
            <Txt
              color="#757588"
              fs={11}
            >{`Purchased on: ${row.purchased_on}`}</Txt>
          </Div>
        </Div>
      ));
    }
    return (
      <Div className="flex justify-between fs-13 wa-tr-row center">
        <Txt color="#757588">{key}</Txt>
        <Div className="text-right">
          <Txt color="#22234E" b>
            {value[0].name}
          </Txt>
          <Txt
            color="#757588"
            fs={11}
          >{`Purchased on: ${value[0].purchased_on}`}</Txt>
        </Div>
      </Div>
    );
  };
  return (
    <Div pb="23px">
      <Div className="flex justify-between center">
        <Div h>
          <Img
            size={42.3}
            src={
              type === "package"
                ? "/self-serve/wallet_2@3x.png"
                : chargeDetails.is_refund
                ? "/self-serve/refund@3x.png"
                : "/self-serve/visit@3x.png"
            }
            mr={10}
          />
          <Div>
            <Txt color="#22234E" fs={18}>
              {chargeDetails.is_cancelled && type !== "ca"
                ? "Cancellation Fee"
                : chargeDetails.is_refund && type !== "ca"
                ? "Visit Refund"
                : ChargeType[type]}
            </Txt>
            <Txt fs={13} color="#8D8DA2" className="mt-1">
              {type === "package" && (
                <Txt color="#9898A6" fs={12} mt={4}>
                  {chargeDetails.package_category}
                  <Txt
                    color="#32BDC7"
                    bg="rgba(50,189,199,0.18)"
                    br={6}
                    fs={11}
                    inline
                    ml={8}
                    p="3.0px 5.6px"
                  >
                    {chargeDetails.package_length}
                  </Txt>
                </Txt>
              )}
              {type === "ca" && chargeDetails.is_cancelled && (
                <Txt color="#9898A6" fs={12} mt={4}>
                  Cancelled
                </Txt>
              )}
              {(type === "visit" || type === "teleconsult" || type === "ca") &&
                chargeDetails.visit_time && (
                  <Txt color="#9898A6" fs={12} mt={4}>
                    <Img size={8.6} src="/self-serve/time@3x.png" mr={6} />
                    {chargeDetails.visit_time}
                  </Txt>
                )}
            </Txt>
          </Div>
        </Div>
        {type === "visit" && (
          <Div h>
            <Txt
              fs={13}
              color="#32BDC7"
              mr={10}
              pointer
              onClick={() =>
                window.open(SMILEY_VISIT_DETAILS + chargeDetails.visit_id)
              }
            >
              Visit details
            </Txt>
            <Img size={12} src="/self-serve/visit-arrow@3x.png" mr={10} />
          </Div>
        )}
      </Div>
      <Div bg="rgba(216, 216, 216,0.3)" br={13} height={94} h hc vc mt={30}>
        <Div textAlign="center" b>
          <Txt fs={27} color="#32BDC7">
            {chargeDetails.is_refund ? "+" : "-"}
            {chargeDetails.amount
              ? chargeDetails.currency === "h"
                ? chargeDetails.amount + chargeDetails.currency
                : `${chargeDetails.currency} ${chargeDetails.amount}`
              : chargeDetails.visit_duration}
          </Txt>
          {charge_status === "upcoming" && type === "teleconsult" && (
            <Txt fs={11} color="#32BDC7">
              & other charges if applicable
            </Txt>
          )}
          <Txt
            color={
              charge_status === "failed"
                ? "#E01A4F"
                : charge_status === "upcoming"
                ? "#A4A4A4"
                : "#7ED321"
            }
            fs={14}
            mt={1}
          >
            {charge_status === "completed"
              ? "Completed Charge"
              : charge_status === "upcoming"
              ? "Upcoming Charge"
              : charge_status === "failed"
              ? "Failed"
              : ""}
          </Txt>
        </Div>
      </Div>
      <Div mt={26}>
        {card_used && (
          <Div>
            <Div className="wa-tr-row">
              <Div className="flex justify-between fs-13 center">
                <Txt color="#757588">
                  {chargeDetails.is_refund ? "Card Refunded to" : "Card Used"}
                </Txt>
                <Div h hc vc>
                  {charge_status === "failed" && (
                    <Img size={12} src="/self-serve/alert@3x.png" mr={4} />
                  )}
                  <img
                    width={19}
                    height={15.5}
                    src={card_used?.image}
                    alt="visa"
                  />
                  <Txt color="#22234E" ml={7}>
                    {`Ending in ${card_used?.ending_at}`}
                  </Txt>
                </Div>
              </Div>
              {charge_status === "failed" && !card_used?.is_card_updated && (
                <Div
                  bg="#F4EAED"
                  br={8}
                  p="17px"
                  fs={13}
                  color="#626262"
                  mt={14}
                >
                  <Div className="flex justify-between center">
                    <Div>
                      <Txt fs={10} color="#A4A4A4">
                        ERROR
                      </Txt>
                      <Txt mt={3} color="#E01A4F">
                        generic_decline
                      </Txt>
                    </Div>
                    {!isErrorDetail && (
                      <Div
                        color="#32BDC7"
                        onClick={() => setErrorDetail(true)}
                        className="pointer"
                      >
                        More Details
                      </Div>
                    )}
                  </Div>
                  {isErrorDetail && (
                    <Div>
                      <Txt mt={12} fs={10} color="#A4A4A4">
                        DESCRIPTION
                      </Txt>
                      <Txt mt={5}>
                        The card has been declined for an unknown reason.
                      </Txt>

                      <Txt mt={12} fs={10} color="#A4A4A4">
                        Next Steps
                      </Txt>
                      <Txt mt={5}>
                        The customer needs to contact their card issuer for more
                        information.
                      </Txt>
                    </Div>
                  )}
                </Div>
              )}
              {charge_status === "failed" && card_used?.is_card_updated && (
                <Div
                  className="flex justify-between center"
                  bg="#E3F0E1"
                  br={8}
                  p="7px 10px"
                  fs={13}
                  color="#626262"
                  mt={14}
                >
                  <Div fs={13} color="#A4A4A4" width={250}>
                    Please update the card to ensure that the visits run
                    smoothly.
                  </Div>
                  <Div color="#63D321">Card updated</Div>
                </Div>
              )}
            </Div>
          </Div>
        )}

        {renderDetailRow("Claim Type", chargeDetails.claim_type)}
        {renderDetailRow(
          "Reason for adjustment",
          chargeDetails.reason_of_adjustment
        )}
        {renderDetailRow(
          "Payment Method",
          chargeDetails?.payment_method?.manual_used
        )}
        {renderDetailRow("Package name", chargeDetails.package_name)}
        {renderDetailRow("Validity", chargeDetails.validity)}
        {renderDetailRow(
          "Paid by",
          chargeDetails?.payment_method?.method === "fpx" &&
            chargeDetails?.payment_method?.fpx_used
        )}
        {renderPackageUsed("Package Used", chargeDetails.packages_used)}
        {renderDetailRow(
          chargeDetails.is_refund ? "Refund date" : "Charge Date",
          chargeDetails.charge_date
        )}
        {renderDetailRow("Package ID", chargeDetails.package_id)}
        {!chargeDetails.package_id &&
          renderDetailRow(
            "Package ID",
            chargeDetails.packages_used?.[0]?.package_id
          )}
        {renderDetailRow("Transaction ID", chargeDetails.transaction_id)}
        {renderDetailRow(
          "Stripe Receipt Number",
          chargeDetails.stripe_receipt_no
        )}
        {renderDetailRow("Care Recipient", chargeDetails.care_recipient)}
        {renderDetailRow("Visit ID", chargeDetails.visit_id)}
      </Div>
    </Div>
  );
};

export default ChargeDetails;
